import { InjectionToken, makeStateKey } from '@angular/core';
import { SeoPageDetail } from './seo-page.models';

/**
 * Request-scoped SEO page payload. The server renderer (P06) resolves the path once before
 * rendering and provides this token per render; it is never kept in a module-level singleton.
 */
export interface SeoRenderPayload {
  /** Exact resolved request path (no query or fragment). */
  path: string;
  revision: string;
  page: SeoPageDetail;
}

export const SEO_PAGE_RENDER_PAYLOAD = new InjectionToken<SeoRenderPayload>('SEO_PAGE_RENDER_PAYLOAD');

/** Public payload serialized for hydration; the browser consumes and removes it once. */
export const SEO_PAGE_TRANSFER_KEY = makeStateKey<SeoRenderPayload>('bla54.seo-page');
